
import { types,ModelInstanceTypeProps,ModelProperties } from 'mobx-state-tree';
import { IInformationObject } from '../../common/components/information-manager/IInformationManagerInterface';


/** 
 * @description Information Model Initialization
 */
export const CQInformationModel = types.model({
    informationalMessage: types.string,
    componentName: types.string,
    informationalFlag: types.boolean,
})
    .actions((self: ModelInstanceTypeProps<ModelProperties>) => ({
        dispatchError(error: IInformationObject) {
            self.informationalMessage = error.informationalMessage;
            self.componentName = error.componentName;
            self.informationalFlag = true;
        },
        hide() {
            self.informationalFlag = false;
        }
    }));